import React, { useState } from 'react';
import { ChevronDown, CheckSquareIcon } from 'lucide-react';
export function OrderBumpSection() {
  const [isOpen, setIsOpen] = useState(false);
  return <section className="pt-8 pb-12 px-5" data-id="element-193">
      <div className="max-w-lg mx-auto" data-id="element-194">
        <div className="rounded-2xl border-2 border-dashed border-teal p-6 relative overflow-hidden flex flex-col shadow-lg" style={{
        backgroundColor: '#F0F7FF'
      }} data-id="element-195">
          {/* Header */}
          <div className="text-center mb-5" data-id="element-196">
            <h3 className="text-lg font-bold text-charcoal tracking-wide" data-id="element-197">
              ⚠️ ACCESO EXCLUSIVO: EVITA DESTROZOS Y ANSIEDAD (Oferta Única)
            </h3>
          </div>

          {/* Product Image — 15% smaller with drop shadow */}
          <div className="mb-5 flex justify-center" data-id="element-198">
            <img src="https://cdn.magicpatterns.com/uploads/8Var6xUnyMYhjUzZj5mkj8/orderbump_nuevo.png" alt="El Código del Silencio - Manual Anti-Ansiedad" className="w-3/5 h-auto rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.15)]" data-id="element-199" />
          </div>

          {/* Copy */}
          <div className="text-center mb-6" data-id="element-200">
            <p className="text-charcoal/80 leading-relaxed mb-5 text-[15px]" data-id="element-201">
              El 85% de nuestros alumnos añade "El Código del Silencio" para
              asegurar que la calma del paseo se traslade también al hogar.
              Aprenda el protocolo técnico para eliminar ladridos y destrozos
              cuando sale de casa por solo 4,90€ más.{' '}
              <span className="text-charcoal/50 line-through text-sm" data-id="element-202">
                (Precio normal 27€)
              </span>
            </p>

            {/* CTA Button */}
            <button className="w-full bg-accent hover:bg-accent-dark text-white font-bold text-base py-4 rounded-full shadow-[0_0_20px_rgba(39,174,96,0.3)] flex items-center justify-center gap-2.5 transition-colors border border-accent-light/30" data-id="element-203">
              <CheckSquareIcon className="w-5 h-5" data-id="element-204" />
              SÍ, AÑADIR AL PEDIDO (+4,90€)
            </button>
          </div>

          {/* Accordion */}
          <div className="mt-auto pt-4 border-t border-charcoal/10" data-id="element-205">
            <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between text-left focus:outline-none group" data-id="element-206">
              <span className="text-sm font-semibold text-charcoal/70 group-hover:text-charcoal transition-colors" data-id="element-207">
                ¿Cómo protege mi hogar?
              </span>
              <ChevronDown className={`w-4 h-4 text-charcoal/40 transition-transform duration-300 ${isOpen ? 'rotate-180 text-charcoal' : ''}`} data-id="element-208" />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-209">
              <div className="p-4 rounded-xl bg-charcoal/5 border border-charcoal/10 space-y-3 text-sm text-charcoal/70 text-left" data-id="element-210">
                <p data-id="element-211">
                  El manual definitivo para eliminar la Ansiedad por Separación
                  antes de que se convierta en un problema legal o de
                  convivencia.
                </p>
                <p data-id="element-212">
                  <strong className="text-charcoal" data-id="element-213">
                    El Ritual de Salida 'Sordo':
                  </strong>{' '}
                  Cómo romper la asociación de las llaves y zapatos con el
                  pánico.
                </p>
                <p data-id="element-214">
                  <strong className="text-charcoal" data-id="element-215">Cero Destrozos:</strong> La
                  técnica de la 'Habitación Segura' para que tu sofá y puertas
                  sobrevivan a tu ausencia.
                </p>
                <p data-id="element-216">
                  <strong className="text-charcoal" data-id="element-217">
                    Monitorización 2026:
                  </strong>{' '}
                  Cómo usar tecnología gratuita para saber si tu perro está
                  tranquilo en tiempo real.
                </p>
                <p data-id="element-218">
                  <strong className="text-charcoal" data-id="element-219">Resultado:</strong> Sal de
                  casa con la tranquilidad de que tu perro está en silencio y
                  relajado.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}